import React from 'react';

const STATUS_LABELS = {
  0: 'Pending',
  1: 'Prematch',
  2: 'In Progress',
  3: 'Ended',
};

const TimelineOverview = ({ roundTotalScore, minutes, statusId, roundTotalCorners }) => (<div className="round-special-panel m-t-30">
  <span className="m-r-10 m-l-10">
      Total Goals: {roundTotalScore}
  </span>
  <span className="m-r-10 m-l-10">
      Total Corners: {roundTotalCorners}
  </span>
  <span className="m-r-10 m-l-10">
      Minutes: {minutes ? `${minutes}'` : ''}
  </span>
  <span className="m-r-10 m-l-10">
    {STATUS_LABELS[statusId]}
  </span>
</div>);

export default TimelineOverview;